import { formatCurrencyOrNumber } from './number/roundToDecimals';

export function formatCurrency(value: number): string {
  return formatCurrencyOrNumber(value, {
    currency: 'USD',
    decimals: 0,
    useGrouping: true,
  });
}

export function formatLargeNumber(value: number, includeCurrency = false): string {
  const absValue = Math.abs(value);
  const prefix = includeCurrency ? '$' : '';
  const sign = value < 0 ? '-' : '';

  if (absValue >= 1e9) {
    return `${sign}${prefix}${(absValue / 1e9).toFixed(1)}B`;
  }
  if (absValue >= 1e6) {
    return `${sign}${prefix}${(absValue / 1e6).toFixed(1)}M`;
  }
  if (absValue >= 1e3) {
    return `${sign}${prefix}${(absValue / 1e3).toFixed(1)}K`;
  }

  return `${sign}${prefix}${absValue.toFixed(1)}`;
}

export function formatGEXValue(value: number): string {
  return formatLargeNumber(value, true);
}

export function formatPercentage(value: number, decimals: number = 2): string {
  return `${value.toFixed(decimals)}%`;
}

export function formatPrice(value: number): string {
  return formatCurrencyOrNumber(value, {
    currency: 'USD',
    decimals: 2,
    useGrouping: true,
  });
}